/**
 * Whether `/api/images/event/[id]` can actually return a cover.
 *
 * This is the events-side twin of `clusterHasImage`, and it exists for
 * the same reason: the front-end has to gate on what the image endpoint
 * will *do*, not on one field it happens to read.
 *
 * The event image route resolves in two stages:
 *
 *   1. `imageUrl` — the poster stored at ingest time. That is real
 *      Ticketmaster art, a Biletix poster, or freely-licensed Wikimedia
 *      photography, in that order of preference.
 *   2. If there is no stored poster, the artists' Spotify photography,
 *      through the same `resolveImageResponse` pipeline the cluster
 *      route uses.
 *
 * A card that checked only `event.imageUrl` would therefore render the
 * aurora placeholder for every event whose cover comes from stage 2 —
 * which, after Ticketmaster stopped supplying usable artwork for the
 * Turkish market, is a meaningful slice of the feed.
 *
 * Do not hand-roll this check. If you add a stage to the route, add it
 * here in the same change, or the two drift apart silently.
 */
export function eventHasImage(event: {
  imageUrl: string | null;
  artists: ReadonlyArray<{ spotifyId: string | null }>;
}): boolean {
  if (event.imageUrl) return true;
  return event.artists.some((artist) => Boolean(artist.spotifyId));
}
